import gql from "graphql-tag";

export const MARK_MESSAGES_TO_REPROCESS = gql(`
    mutation m($filter: FilterInput) {
        agatheMessageOutService_markMessagesToReprocess(filter: $filter)
    }`);

